import { useNavigate } from 'react-router-dom';

interface FavoriteClassRowProps {
  title: string;
  description: string;
  studioSlug?: string;
  classSlug?: string;
  onUnfavorite: () => void;
}

export const FavoriteClassRow = ({ title, description, studioSlug, classSlug, onUnfavorite }: FavoriteClassRowProps) => {
  const navigate = useNavigate();
  
  const handleCardClick = () => {
    if (studioSlug && classSlug) {
      navigate(`/clases/${studioSlug}/${classSlug}/000000000`);
    }
  };

  const handleUnfavoriteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onUnfavorite();
  };

  return (
    <div 
      className="flex items-center justify-between p-4 border-b bg-white max-w-5xl mx-auto border border-gray-300 rounded-lg cursor-pointer hover:shadow-md transition-shadow duration-200"
      onClick={handleCardClick}
    >
      <div>
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
      <button 
        className="px-3 py-1 text-sm rounded bg-red-500 text-white hover:bg-red-600 transition-colors cursor-pointer"
        onClick={handleUnfavoriteClick}
      >
        Quitar de favoritos
      </button>
    </div>
  );
};